import { useEffect, useRef } from "react";

function useInterval(callback, delay) {
  const savedCallback = useRef();
	
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
	function load() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
	  //console.log(id)
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default useInterval;
